import { render, staticRenderFns } from "./SalaryDetail.vue?vue&type=template&id=8cdf5bb6&"
import script from "./SalaryDetail.vue?vue&type=script&lang=js&"
export * from "./SalaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports